import React, { useCallback } from 'react';
import { Form, InputNumber, Slider, Typography } from 'antd';
import debounce from 'lodash/debounce';
import { stringMixin } from '../../utils/strings';

const IncomeModelConfigurator = ({ onConfigChange }) => {
  const [form] = Form.useForm();

  // Debounce the callback function
  const debouncedOnConfigChange = useCallback(
    debounce((allValues) => {
      onConfigChange(allValues);
    }, 300), // 300ms debounce
    []
  );

  const handleValuesChange = (changedValues, allValues) => {
    debouncedOnConfigChange(allValues);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={handleValuesChange}
      initialValues={{
        initial_capital: 100000,
        ppy: 2,
        withdrawal_rate: 0.03,
        min_withdrawal_amount: 0,
      }}
    >
      <Form.Item name="initial_capital" label="Initial Capital">
        <InputNumber min={0} step={1000} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="ppy" label={
          <Typography.Text>
              <Typography.Text strong>({form.getFieldValue('ppy')})</Typography.Text> Distributions a Year
          </Typography.Text>
      }>
        <Slider min={1} max={12} step={1} marks={{
            '1': "1",
            '12': "12",
        }} />
      </Form.Item>
      <Form.Item name="withdrawal_rate" label={
          <Typography.Text>
              <Typography.Text strong>({stringMixin.pct(form.getFieldValue('withdrawal_rate'))})</Typography.Text> Annual Rate
          </Typography.Text>}>
        <Slider
          min={0}
          max={0.25}
          step={0.001}
          tipFormatter={(value) => `${(value * 100).toFixed(1)}%`}
          marks={{
            '0': '0%',
            '0.1': '10%',
            '0.25': '25%',
          }}
        />
      </Form.Item>
      <Form.Item name="min_withdrawal_amount" label="Minimum Withdrawal Amount">
        <InputNumber min={0} step={100} style={{ width: '100%' }} />
      </Form.Item>
    </Form>
  );
};

export default IncomeModelConfigurator;
